import { Tooltip, TooltipPosition } from "@kamae-apps/shared/Components/Atoms/Tooltip/Tooltip"
import Icon from "@kamae-apps/shared/Components/Fondations/Icons/Icon"
import { IconNames } from "@kamae-apps/shared/Components/Fondations/Icons/IconNames.type"
import clsx from "clsx"
import { FC } from "react"
import { useNavigate } from "react-router-dom"

type MenuEntryProps = {
  content: string
  iconName: IconNames
  goTo: string
  isActive: boolean
  isDisabled: boolean
  tooltip: string
}

export const MenuEntry: FC<MenuEntryProps> = ({ content, iconName, goTo, isDisabled, isActive, tooltip }) => {
  const navigate = useNavigate()
  return (
    <button
      disabled={isDisabled}
      onClick={() => navigate(goTo)}
      className={clsx(
        "h-13 w-13 flex items-center justify-between rounded-xl p-4 transition-all duration-300 rebranding-sm:w-full",
        isActive && "bg-primary-kamae-50 rebranding-sm:bg-white",
        !isActive && !isDisabled && "bg-transparent hover:bg-white hover:bg-opacity-50"
      )}
      type={"button"}
    >
      <span
        className={clsx(
          "flex items-center gap-3",
          isActive && "text-primary-kamae-500",
          !isActive && isDisabled && "text-neutral-gray-400",
          !isActive && !isDisabled && "text-neutral-gray-600"
        )}
      >
        <Icon name={iconName} />
        <Tooltip
          tooltipPosition={"tooltip-right"}
          title={tooltip}
          display={isDisabled}
        >
          <p
            className={clsx(
              "hidden lg:block",
              isActive ? "caption-semibold" : "caption-regular",
              isDisabled ? "text-neutral-gray-400" : "text-neutral-gray-900"
            )}
          >
            {content}
          </p>
        </Tooltip>
      </span>
      <span className={clsx("hidden lg:block text-neutral-gray-600", isActive ? "opacity-100" : "opacity-0")}>
        <Icon name="chevronRight" />
      </span>
    </button>
  )
}
